// extracted by css-extract-rspack-plugin
export default {"gridControl":"AddressData_gridControl__yAdlK","wrapper":"AddressData_wrapper__jxaNk","right":"AddressData_right__dDtni","inlineRadio":"AddressData_inlineRadio__-n586"};